import gql from 'graphql-tag';

import { GetUserRewindQuery, Maybe } from 'types/graphql-api.generated';

import requestGraph from 'common/api/GraphApi/requestGraph';
import {
  USER_REWIND_FRAGMENT,
  USER_REWIND_ME_FRAGMENT,
  USER_REWIND_MOVIE_FRAGMENT,
  USER_REWIND_SERIES_FRAGMENT
} from 'common/api/UserRewindFragments';

export type UserRewindData = {
  data?: Maybe<GetUserRewindQuery>;
};

export const getUserRewind = async (
  releaseFrom?: string,
  releaseTo?: string
) => {
  const now = new Date();
  const from = releaseFrom || now.toISOString();
  const to =
    releaseTo ||
    new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000).toISOString();

  const QUERY = gql`
    query GetUserRewind($releaseFrom: DateTime!, $releaseTo: DateTime!) {
      movieList(
        order: WEEKLY_POPULARITY
        releaseFrom: $releaseFrom
        releaseTo: $releaseTo
        first: 5
      ) {
        edges {
          node {
            ...UserRewindMovieFragment
          }
        }
      }
      seriesList(
        startsFrom: $releaseFrom
        startsTo: $releaseTo
        order: QUARTERLY_POPULARITY
        first: 5
      ) {
        edges {
          node {
            ...UserRewindSeriesFragment
          }
        }
      }
      me {
        user {
          ...UserRewindMeFragment
          social {
            ...UserRewindFragment
          }
        }
      }
    }
    ${USER_REWIND_FRAGMENT}
    ${USER_REWIND_ME_FRAGMENT}
    ${USER_REWIND_MOVIE_FRAGMENT}
    ${USER_REWIND_SERIES_FRAGMENT}
  `;

  const response = await requestGraph<UserRewindData>({
    query: QUERY,
    variables: { releaseFrom: from, releaseTo: to }
  });

  return response.data;
};
